module.exports = __webpack_public_path__ + "assets/img/21de-bm.svg";